import styles from './index.module.scss';
import { useEffect, useState } from 'react';
import { getSolarRecommand2 } from '@/service/solar-calculator';
import { useRouter } from 'next/router';
import { cloneDeep } from 'lodash';
import { Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import EFPicture from '@elem/ui/ef-picture';

interface Props {
    title: string;
    items: {
        img: string;
        label: string;
        productId: string;
        variantId: string;
        learnMore: string;
    }[];
}

const CommonProducts: React.FC<Props> = (props) => {
    const { items, title } = props;
    const { locale = 'ca' } = useRouter();

    const [reactiveItems, setReactiveItems] = useState(items);

    const [sliderConfig, setSliderConfig] = useState({
        slidesPerView: 'auto',
        spaceBetween: 14,
    });

    useEffect(() => {
        setSliderConfig({
            slidesPerView: window.innerWidth > 1024 ? Math.min(reactiveItems.length, 3) : 'auto',
            spaceBetween: window.innerWidth > 1024 ? 30 : 14,
        });
    }, [reactiveItems.length]);

    useEffect(() => {
        getItemInfo();
    }, []);

    async function getItemInfo() {
        const variantIds = items.map((item) => item.variantId);
        const res = await getSolarRecommand2({ variantIds }, locale);
        if (res.code === '0') {
            const newItems = cloneDeep(reactiveItems);
            res.data.forEach((item: any) => {
                const newItem = newItems.find((_item) => _item.variantId === item.variantId);
                if (newItem) {
                    newItem.img = item.variantImg;
                }
            });

            setReactiveItems(newItems);
        }
    }

    function handleLink(link: string) {
        window.open(link, '_blank');
    }

    return (
        <div className={styles.CommonProducts}>
            <div className="title">{title}</div>
            <div className="wrapper">
                <Swiper
                    slidesPerView={sliderConfig.slidesPerView}
                    spaceBetween={sliderConfig.spaceBetween}
                    pagination={{
                        clickable: true,
                    }}
                    modules={[Pagination]}
                >
                    {reactiveItems.map((item) => {
                        return (
                            <SwiperSlide className="wrapper-item" key={item.label}>
                                <EFPicture src={item.img} />
                                <div className="label">{item.label}</div>
                                <div className="more" onClick={() => handleLink(item.learnMore)}>
                                    Learn more
                                </div>
                            </SwiperSlide>
                        );
                    })}
                </Swiper>
            </div>
        </div>
    );
};

export default CommonProducts;
